import React from 'react';

import { compose } from 'ramda';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import ModalBox from '@synergycms_core/components/generic/Modal/ModalBox';



 class SibsFrame extends React.Component {
  static displayName = 'SibsFrame';

  componentDidMount =() =>{
    document.getElementById('sibsAutoForm').submit();
  }

  render() {
    const { closeModal, src, creq } = this.props.config;

    return (
      <ModalBox close={closeModal}>
        <div>
          <iframe id="sibsFrame" name="sibsFrame" title="SIBS 3DS" style={{ width: '100%', height: '500px', border: '2px solid black' }}></iframe>
          <form id="sibsAutoForm" action={src} method="post" target="sibsFrame">
            <input type="hidden" name="creq" value={creq} />
          </form>
        </div>
      </ModalBox>
    );
  }
}


export default compose(
  PropertyManager([
    "closeModal",
    "src",
    "creq"
  ]),
  withThemeJSS({ styleFile })
)(SibsFrame);
